import {
  Button,
  Col,
  DatePicker,
  InputNumber,
  Row,
  Form,
  Typography,
  Select,
  Spin,
  Input,
} from "antd";
import React, { useState } from "react";
import { getUnits } from "../../services/unitService";
import { debounce } from "../Common/Debounce";

const { Text } = Typography;

function UnitOfferForm({ initialValues, onSubmit, status, setStatus, type }) {
  const [fetching, setFetching] = useState(false);
  const [fetchedUnits, setFetchedUnits] = useState([]);
  const dateFormat = "Do MMMM YYYY h:mm:ssA Z";

  const fetchUnitsHandler = debounce((unitSearch) => {
    setFetching(true);
    getUnits(0, 0, {
      unitSearch,
    })
      .then((response) => {
        const data = response.data.paginatedList.map((unit) => ({
          label: `${unit.code}: ${unit.description}`,
          value: unit.unitId,
        }));
        setFetchedUnits(data);
        setFetching(false);
      })
      .catch((err) => {
        setStatus({
          error: true,
          message: `${err}`,
        });
      });
  }, 250);

  return (
    <Form
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 14 }}
      onFinish={onSubmit}
      initialValues={initialValues}
    >
      <Form.Item label="Course Offer Id*" name="courseOfferId">
        <Text>{initialValues.courseOfferId}</Text>
      </Form.Item>
      <Form.Item label="Unit*" name="unitId">
        {type.toLowerCase().includes("add") ? (
          <Select
            mode={""}
            placeholder="Search units"
            options={fetchedUnits}
            notFoundContent={fetching ? <Spin size="small" /> : null}
            filterOption={false}
            showSearch={true}
            onSearch={fetchUnitsHandler}
            style={{ width: "100%" }}
          ></Select>
        ) : (
          <Text>
            {initialValues.unitCode}: {initialValues.unitDescription}
          </Text>
        )}
      </Form.Item>

      {type.toLowerCase().includes("add") ? (
        <></>
      ) : (
        <Form.Item
          label="Unit Description"
          name="unitDescription"
          rules={[
            { required: true, message: "Please input unit description!" },
          ]}
        >
          <Input />
        </Form.Item>
      )}

      <Form.Item
        label="Start Date (Local)"
        name="startDate"
        rules={[{ required: true, message: "Please input start date!" }]}
      >
        <DatePicker
          showTime={true}
          showNow={false}
          format={dateFormat}
          style={{ width: "100%" }}
        />
      </Form.Item>
      <Form.Item
        label="End Date (Local)"
        name="endDate"
        rules={[{ required: true, message: "Please input end date!" }]}
      >
        <DatePicker
          showTime={true}
          showNow={false}
          format={dateFormat}
          style={{ width: "100%" }}
        />
      </Form.Item>
      <Form.Item
        label="Min Registrations"
        name="minRegistrations"
        rules={[{ required: true, message: "Please input min registrations!" }]}
      >
        <InputNumber min={0} />
      </Form.Item>
      <Form.Item
        label="Max Registrations"
        name="maxRegistrations"
        rules={[{ required: true, message: "Please input max registrations!" }]}
      >
        <InputNumber min={0} />
      </Form.Item>
      {status.type === "ERROR" ? (
        <Text type="danger">{status.message}</Text>
      ) : null}
      {status.type === "SUCCESS" ? (
        <Text type="success">Sucessful!</Text>
      ) : null}
      <Row justify="end" gutter={12}>
        <Col>
          <Button type="primary" htmlType="submit">
            {type}
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default UnitOfferForm;
